import { Button, styled, TableCell } from '@nextiva/next-ui-components';

export const ButtonStyled = styled(Button)`
  &.MuiButton-sizeMedium {
    padding: 12px 16px;
    height: 40px;
  }
`;

export const ButtonStyled2 = styled(Button)`
  &.MuiButton-sizeMedium {
    padding: 12px 17px;
  }
`;

export const ButtonDelete = styled(Button)`
  &.MuiButton-sizeMedium.MuiButton-text {
    padding: 12px 18px;
    height: 40px;
    width: 80px;
  }
`;

export const ButtonDownload = styled(Button)`
  &.MuiButton-sizeMedium.MuiButton-text {
    padding: 12px 28px;
  }
`;

export const TableCellStyled = styled(TableCell)`
  &.MuiTableCell-head {
    color: #55596b;
  }
  &.MuiTableCell-body {
    color: #0b1029;
    &[data-status='rejected'] {
      color: ${({ theme }) => theme.palette.error.main};
    }
  }
`;
